import { render } from "./form-checkbox-radios.vue?vue&type=template&id=19a7ec21"
import script from "./form-checkbox-radios.vue?vue&type=script&lang=js"
export * from "./form-checkbox-radios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__